export default {
    apiServerUrl: 'https://sklad-crm.devsafi.pl/'
};